import { useQuery } from "react-query";
import { clearStoredAuth } from "../utils";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { useDeleteFleet } from "../hooks/useFleet";
import { API_URL } from "../config";
import { EMPTY_FLEET } from "../constants";

export const buildFleetsUrl = (operatorRef?: number | null) => {
  const searchParams = new URLSearchParams();
  if (operatorRef) {
    searchParams.set("operator_ref", String(operatorRef));
  }
  const query = searchParams.toString();
  return `${API_URL}/fleets${query ? `?${query}` : ""}`;
};

const fetchFleets = async (operatorRef?: number | null) => {
  const res = await fetch(buildFleetsUrl(operatorRef), {
    credentials: "include",
  });
  // TODO: process error
  if (!res.ok) {
    throw new Error(`${res.status}`);
  }

  return res.json();
};

export const useFleets = (operatorRef?: number | null, enabled = true) => {
  const [selectedFleet, setSelectedFleet] = useState(EMPTY_FLEET);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const navigate = useNavigate();

  const deleteMutation = useDeleteFleet();

  const handleOpenDeleteModal = (fleet: Fleet) => {
    if (fleet.id) {
      setSelectedFleet(fleet);
      setIsDeleteModalOpen(true);
    }
  }

  const handleDeleteFleet = () => {
    if (selectedFleet.id) {
      deleteMutation.mutate(selectedFleet.id);
      setIsDeleteModalOpen(false);
    }
  }

  const handleOpenEditModal = (fleet: Fleet) => {
    if (fleet.id) {
      setSelectedFleet(fleet);
      setIsEditModalOpen(true);
    }
  }

  const fleets = useQuery(["fleets", operatorRef || "current"], () => fetchFleets(operatorRef), {
    enabled,
    refetchOnWindowFocus: false,
    retry: 1,
    onError: (error: Error) => {
      if (error.message === "401") {
        clearStoredAuth();
        navigate("/");
      }
    },
  })

  return {
    fleets,
    setIsDeleteModalOpen,
    handleOpenDeleteModal,
    isDeleteModalOpen,
    handleDeleteFleet,
    setIsEditModalOpen,
    handleOpenEditModal,
    isEditModalOpen,
    selectedFleet,
  };
};
